import { render, staticRenderFns } from "./Spin.vue?vue&type=template&id=5e5ab372&"
import script from "./Spin.vue?vue&type=script&lang=js&"
export * from "./Spin.vue?vue&type=script&lang=js&"
import style0 from "./Spin.vue?vue&type=style&index=0&id=5e5ab372&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/test-tripanels/clusterpanels/hwy-client-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e5ab372')) {
      api.createRecord('5e5ab372', component.options)
    } else {
      api.reload('5e5ab372', component.options)
    }
    module.hot.accept("./Spin.vue?vue&type=template&id=5e5ab372&", function () {
      api.rerender('5e5ab372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Spin.vue"
export default component.exports